module.exports = __webpack_public_path__ + "images/PlayAGS-aea4a0.png";